import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import { euro, imgSrc } from "@/lib/api";

export const AlternativesSheet = ({ open, onClose, entry, products, currentId, onChoose }) => (
  <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
    <SheetContent side="bottom" className="bg-[#FAF8F5] max-h-[85vh] overflow-y-auto rounded-t-2xl border-[#E6DFD5]" data-testid="alternatives-sheet">
      {entry && (
        <div className="max-w-2xl mx-auto w-full pb-6">
          <SheetHeader className="text-left">
            <p className="fs-eyebrow">{entry.step_name}</p>
            <SheetTitle className="font-serif text-3xl font-normal">Alternative compatibili</SheetTitle>
            <SheetDescription className="text-sm text-[#8C8275]">Il nostro consiglio è in fascia medio-alta; in alternativa l'opzione più economica e quella più completa, sempre adatte al tuo profilo.</SheetDescription>
          </SheetHeader>
          <ul className="mt-6 divide-y divide-[#E6DFD5]">
            {entry.candidates.map((id) => {
              const p = products[id];
              if (!p) return null;
              const current = id === currentId;
              return (
                <li key={id} className="py-5 flex gap-4 items-center" data-testid={`alternative-item-${id}`}>
                  <div className="w-16 h-20 bg-[#F2ECE4] shrink-0 overflow-hidden">
                    {p.image && <img src={imgSrc(p.image)} alt={p.name} className="w-full h-full object-cover" />}
                  </div>
                  <div className="flex-1 min-w-0">
                    {entry.alt_labels?.[id] && <p className="text-[10px] tracking-[0.2em] uppercase text-[#8C6F3E] mb-1" data-testid={`alternative-label-${id}`}>{entry.alt_labels[id]}</p>}
                    {id === entry.primary_id && <p className="text-[10px] tracking-[0.2em] uppercase text-[#8C6F3E] mb-1">Il nostro consiglio</p>}
                    <p className="font-serif text-lg leading-tight">{p.name}</p>
                    <p className="text-xs text-[#8C8275] mt-1 line-clamp-2">{(p.matched_labels || []).join(" · ") || p.why_text}</p>
                    <p className="text-sm mt-1 tabular-nums">{euro(p.price)}</p>
                  </div>
                  {current ? (
                    <span className="fs-eyebrow text-[#8C6F3E]">Selezionato</span>
                  ) : (
                    <button data-testid={`replace-product-btn-${id}`} className="fs-btn !px-5 !py-3" onClick={() => onChoose(id)}>Scegli</button>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </SheetContent>
  </Sheet>
);
